import React from "react";
import { Link } from "gatsby";
import Layout from "components/layout";
import SEO from "components/seo";
import Image from "components/image";
import Style from "styles/news_detail.module.scss";
import { newsList } from "../../news_data";

const PATH = "/news/jitera-partnership/";
const PRESS_RELEASE_URL = "https://www.value-press.com/pressrelease/375880";
const PRESS_RELEASE_PRTIMES_URL =
  "https://prtimes.jp/main/html/rd/p/000000071.000110428.html";

const news = newsList.find((item) => item.path === PATH);

const JiteraPartnership = () => (
  <Layout>
    <SEO
      title="Jiteraとセールスパートナー契約を締結しました"
      path="news/jitera-partnership"
    />
    <article className={Style.container}>
      <header className={Style.detailHead}>
        <time className={Style.detailHead__date}>{news.date}</time>
        <h1 className={Style.detailHead__title}>
          Jiteraとセールスパートナー契約を締結しました
        </h1>
      </header>

      {news.image ? (
        <div className={Style.detailImage}>
          <Image
            filename={news.image}
            alt="Jiteraとのセールスパートナー契約締結"
          />
        </div>
      ) : null}

      <div className={Style.detailBody}>
        <p className={Style.detailBody__lead}>
          このたび株式会社イーゼは、AIコンテキストプラットフォームを展開する株式会社Jiteraと、セールスパートナー契約を締結いたしました。
          Jiteraの活用により、要件定義からコード生成までを一貫して支援し、開発のさらなる高速化と品質向上、そして企業のDX・AI化を後押ししてまいります。
        </p>
        <h2 className={Style.detailBody__heading}>提供価値</h2>
        <ul className={Style.detailBody__list}>
          <li>開発プロセスの高速化</li>
          <li>既存システムのAI現代化</li>
          <li>柔軟な仕様変更への対応</li>
        </ul>
        <p className={Style.detailBody__note}>
          プレスリリースの全文は以下からご覧いただけます。
        </p>
      </div>

      <div className={Style.detailLinks}>
        <a
          className={Style.detailLinks__btn}
          href={PRESS_RELEASE_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          プレスリリース全文を読む（VALUE PRESS）
        </a>
        <a
          className={Style.detailLinks__sub}
          href={PRESS_RELEASE_PRTIMES_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          PR TIMESで見る
        </a>
      </div>

      <div className={Style.detailBack}>
        <Link className={Style.detailBack__link} to="/news/">
          ＜ 新着情報一覧へ戻る
        </Link>
        <Link className={Style.detailBack__link} to="/">
          ＜ TOPへ戻る
        </Link>
      </div>
    </article>
  </Layout>
);

export default JiteraPartnership;
